import React from "react";

export default function Intro(){
    return(
        <div className="wrapper" style={{height:"100%"}}>
            <div className='full-height' style={{height:"100%"}}>
                <object data={`${process.env.REACT_APP_INTRO_URL}`} title="Intro Page" style={{width: '100%', height: '100%'}}/>
            </div>
        </div>
    )
}
